import { PlanService } from './../../../data/repository/plan-repository/plan.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-referral-dialog',
  templateUrl: './referral-dialog.component.html',
  styleUrls: ['./referral-dialog.component.scss'],
})
export class ReferralDialogComponent implements OnInit {
  constructor(
    private dialogref: MatDialogRef<any>,
    private planService: PlanService
  ) {}

  ngOnInit() {}

  onAcceptAction() {
    this.dialogref.close();
    this.planService.goToGenerate();
  }

  onRejectAction() {
    this.dialogref.close();
  }
}
